import axios from 'axios'
import router from '../router'
import {apiURL, aiApiURL, purchaseURL} from "./config";
//


const onUnauthorized = () => {
//   router.push({path: "/auth"});
};

export const setAuthInHeader = (token) => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
};
/*export default function setAuthInHeader (token) {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : null;
}*/

export const request = {
    get(path, data = null) {
        return axios.get(`${apiURL + path}`, {params: data})
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    post(path, data) {
        return axios.post(`${apiURL + path}`, data)
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    aiGet(path, data = null) {
        return axios.get(`${aiApiURL + path}`, {params: data})
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
    aiPost(path, data) {
        return axios.post(`${aiApiURL + path}`, data)
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },

    purchaseGet(path, data = null) {
        return axios.get(`${purchaseURL + path}`, {params: data})
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },

    purchasePost(path, data) {
        return axios.post(`${purchaseURL + path}`, data)
            .catch(({response}) => {
                const {status} = response;
                if (status === 400 || status === 401 || status === 500) {
                    return onUnauthorized();
                } else if (status === Errored) {
                    alert("잘못된 정보입니다.")
                }
                throw Error(response)
            })
    },
};

